// Membaca runtime config dari conf.js (override deployment) atau import.meta.env (build time)
const runtimeEnv = (window as Window & { __ENV__?: Record<string, string> }).__ENV__ ?? {};

function cfg(key: string, fallback = ''): string {
  return runtimeEnv[key] || (import.meta.env[key] as string) || fallback;
}

// Khusus flag boolean: default true bila env tidak diset/kosong, hanya false bila secara
// eksplisit di-set ke "false"/"0"/"no"/"off". Dipakai supaya fitur seperti license check
// bisa di-bypass secara default selama belum siap rilis.
function cfgBool(key: string, fallback: boolean): boolean {
  const raw = (runtimeEnv[key] ?? (import.meta.env[key] as string) ?? '').toString().trim().toLowerCase();
  if (raw === '') return fallback;
  return !['false', '0', 'no', 'off'].includes(raw);
}

export const env = {
  appName: 'App React',
  environment: import.meta.env.MODE,
  queryDebug: cfg('VITE_QUERY_DEBUG') || true,

  apiBaseUrl: cfg('VITE_API_BASEURL'),
  apiTasklistBaseUrl: cfg('VITE_API_TASKLIST_BASEURL'),
  cloudStorage: cfg('VITE_MINIO_CLOUD', 'https://minio.merapi.javan.id'),
  micrositeUrl: cfg('VITE_MICROSITE_URL', 'https://org.saas.merapi.alurkerja.com'),

  // Keycloak Configuration
  keycloakUrl: cfg('VITE_KEYCLOAK_URL', 'https://keycloak.merapi.javan.id'),
  keycloakRealm: cfg('VITE_KEYCLOAK_REALM', 'internal'),
  keycloakClientId: cfg('VITE_KEYCLOAK_CLIENT_ID', 'joglo'),
  keycloakClientSecret: cfg('VITE_KEYCLOAK_CLIENT_SECRET'),
  keycloakRedirectUri: globalThis.location.origin + '/callback',

  sentryDsn: cfg('VITE_SENTRY_DSN'),

  wsCollaborationUrl: cfg('VITE_WS_COLLABORATION_URL', 'wss://collab-ws.alurkerja.com'),
  wsNotificationURl: cfg('VITE_WS_NOTIFICATION_URL') || null,

  // AlurKerja SSO Configuration (existing)
  AK_CLIENT_ID: cfg('VITE_AK_CLIENT_ID', '3'),
  AK_CLIENT_SECRET: cfg('VITE_AK_CLIENT_SECRET'),
  AK_REDIRECT_URI: globalThis.location.origin + '/callback',

  IS_SETTING_ENABLED: cfg('VITE_PRODUCTION') !== 'true',

  SIMULATION_SERVICE_URL: cfg('VITE_SIMULATION_SERVICE_URL', 'https://simulation-onprem.merapi.alurkerja.com'),
  APP_URL: cfg('VITE_APP_URL', 'https://app-onprem.merapi.alurkerja.com'),
  COMPRO_URL: cfg('VITE_COMPRO_URL', 'https://compro-onprem.merapi.alurkerja.com'),
  alurkerjaContactUrl: cfg('VITE_ALURKERJA_CONTACT_URL', 'https://alurkerja.com/contact'),
  urlHelpdeskSupport: cfg('VITE_HELPDESK_SUPPORT_URL', 'https://support-onprem.merapi.alurkerja.com/'),

  // License check toggle. Default false = bypass (fitur masih WIP, belum siap rilis).
  // Set VITE_LICENSE_CHECK_ENABLED=true untuk mengaktifkan pengecekan lisensi.
  licenseCheckEnabled: cfgBool('VITE_LICENSE_CHECK_ENABLED', false),
};
